import * as APITypes from "~/API";
import { Duration, TimeDuration } from "~/types";
import i18n from "~/i18n";

export const durationToDisplay = (range: Duration): string => {
  switch (range) {
    case Duration.Second:
      return i18n.t("second");
    case Duration.Minute:
      return i18n.t("minute");
    case Duration.Hour:
      return i18n.t("hour");
    case Duration.Day:
      return i18n.t("day");
    case Duration.Week:
      return i18n.t("week");
    case Duration.Month:
      return i18n.t("month");
    case Duration.Year:
      return i18n.t("year");
  }
};

export const parseDuration = (value: string): TimeDuration | undefined => {
  const split = value.split(" ");
  if (split.length !== 2) return;
  const num = Number(split[0]);
  const duration = split[1] as Duration;
  return {
    num,
    duration,
  };
};

export const convertDuration = (time: TimeDuration, duration: Duration) => {
  switch (time.duration) {
    case Duration.Second:
      switch (duration) {
        case Duration.Second:
          return time.num;
        case Duration.Minute:
          return time.num / 60;
        case Duration.Hour:
          return time.num / (60 * 60);
        case Duration.Day:
          return time.num / (60 * 60 * 24);
        case Duration.Week:
          return time.num / (60 * 60 * 24 * 7);
        case Duration.Month:
          return time.num / (60 * 60 * 24 * 28);
        case Duration.Year:
          return time.num / (60 * 60 * 24 * 365);
      }
      break;
    case Duration.Minute:
      switch (duration) {
        case Duration.Second:
          return time.num * 60;
        case Duration.Minute:
          return time.num;
        case Duration.Hour:
          return time.num / 60;
        case Duration.Day:
          return time.num / (60 * 24);
        case Duration.Week:
          return time.num / (60 * 24 * 7);
        case Duration.Month:
          return time.num / (60 * 24 * 28);
        case Duration.Year:
          return time.num / (60 * 24 * 365);
      }
      break;
    case Duration.Hour:
      switch (duration) {
        case Duration.Second:
          return time.num * 60 * 60;
        case Duration.Minute:
          return time.num * 60;
        case Duration.Hour:
          return time.num;
        case Duration.Day:
          return time.num / 24;
        case Duration.Week:
          return time.num / (24 * 7);
        case Duration.Month:
          return time.num / (24 * 28);
        case Duration.Year:
          return time.num / (24 * 365);
      }
      break;
    case Duration.Day:
      switch (duration) {
        case Duration.Second:
          return time.num * 60 * 60 * 24;
        case Duration.Minute:
          return time.num * 60 * 24;
        case Duration.Hour:
          return time.num * 24;
        case Duration.Day:
          return time.num;
        case Duration.Week:
          return time.num / 7;
        case Duration.Month:
          return time.num / 28;
        case Duration.Year:
          return time.num / 365;
      }
      break;
    case Duration.Week:
      switch (duration) {
        case Duration.Second:
          return time.num * 60 * 60 * 24 * 7;
        case Duration.Minute:
          return time.num * 60 * 24 * 7;
        case Duration.Hour:
          return time.num * 24 * 7;
        case Duration.Day:
          return time.num * 7;
        case Duration.Week:
          return time.num;
        case Duration.Month:
          return time.num / 4;
        case Duration.Year:
          return time.num / 52;
      }
      break;
    case Duration.Month:
      switch (duration) {
        case Duration.Second:
          return time.num * 60 * 60 * 24 * 28;
        case Duration.Minute:
          return time.num * 60 * 24 * 28;
        case Duration.Hour:
          return time.num * 24 * 28;
        case Duration.Day:
          return time.num * 28;
        case Duration.Week:
          return time.num * 4;
        case Duration.Month:
          return time.num;
        case Duration.Year:
          return time.num / 12;
      }
      break;
    case Duration.Year:
      switch (duration) {
        case Duration.Second:
          return time.num * 60 * 60 * 24 * 365;
        case Duration.Minute:
          return time.num * 60 * 24 * 365;
        case Duration.Hour:
          return time.num * 24 * 365;
        case Duration.Day:
          return time.num * 365;
        case Duration.Week:
          return time.num * 52;
        case Duration.Month:
          return time.num * 12;
        case Duration.Year:
          return time.num;
      }
      break;
  }
};

export const displayReservationPolicy = (
  policy: APITypes.AmenityReservationPolicyOptions,
) => {
  switch (policy) {
    case APITypes.AmenityReservationPolicyOptions.NotAllowed:
      return i18n.t("Not_Allowed");
    case APITypes.AmenityReservationPolicyOptions.Optional:
      return i18n.t("Optional");
    case APITypes.AmenityReservationPolicyOptions.Required:
      return i18n.t("Required");
  }
};
